//Swiper 4 (5.0からはIE11がサポートされていない)
//import Swiper from 'swiper';
//import Swiper from 'swiper/bundle';

// Swiper 6.0
//import Swiper, { Navigation, Pagination } from 'swiper';


export class Swp {
  constructor() {
      this.swipers = [];
      this.targetElems = {};
      //this.swipers[0] = {};
      //Swiper.use([Navigation, Pagination]); // Swiper 6+
      //this.outerNavs = [];
  }

  init() {
      //this.body = document.getElementsByTagName('body')[0];
      //this.html = document.getElementsByTagName('html')[0];
      //console.log('sliders.init');

      if (document.querySelectorAll('.Slider-swiper__container')[0]) {

          this.targetElems = document.querySelectorAll('.Slider-swiper__container');
          for (let i = 0; i < this.targetElems.length; i++) {
              this.swipers[i] = [];
              this.swipers[i]['sliderElem'] = this.targetElems[i].querySelector('.swiper-container');
              this.swipers[i]['thumbs'] = this.targetElems[i].querySelectorAll('.Slider-swiper__thumbs .Slider-swiper__thumb');

              //sliders
              this.swipers[i]['swiper'] = new Swiper(this.swipers[i]['sliderElem'], {
                  autoplay: false,
                  speed: 500,
                  effect: 'slide',
                  loop: true,
                  //slidesPerView: 1,
                  //slidesPerView: 'auto',
                  //centeredSlides: true,
                  //lazy: true,
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  },
                  pagination: {
                      el: '.swiper-pagination',
                  },
                  on: {
                      init: function () {
                          let thumbs = document.querySelectorAll('.Slider-swiper__container')[i].querySelectorAll('.Slider-swiper__thumbs .Slider-swiper__thumb');
                          //console.log(thumbs);

                          thumbs[0].classList.add('selected');
                          for (let j = 0; j < thumbs.length; j++) {
                              thumbs[j].addEventListener('click', () => {
                                  this.slideTo(j + 1);
                                  for (let k = 0; k < thumbs.length; k++) {
                                      if (j == k) {
                                          thumbs[k].classList.add('selected');
                                      } else {
                                          thumbs[k].classList.remove('selected');
                                      }
                                  }
                              });
                          }
                      },
                      slideChange: function () {
                          let thumbs = document.querySelectorAll('.Slider-swiper__container')[i].querySelectorAll('.Slider-swiper__thumbs .Slider-swiper__thumb');
                          //console.log(this.realIndex);

                          for (let j = 0; j < thumbs.length; j++) {
                              if (j == this.realIndex) {
                                  thumbs[j].classList.add('selected');
                              } else {
                                  thumbs[j].classList.remove('selected');
                              }
                          }
                      }
                  }
              });
          }


      }


  }

  getRealIndex(num) {
      console.log(this.swipers[num]['swiper']);
      return 1; //this.swipers[num]['swiper'].progress;
  }

}